import { hCalculator, iStar, iTrendingUp } from '@hover/icons';
import { IProsRestorationInfo } from '../interfaces/IProsRestorationInfo';

export const PROS_NEW_CONSTRUCTION_INFO: Array<IProsRestorationInfo> = [
  {
    id: 0,
    icon: hCalculator,
    header: 'BID FASTER',
    body: 'Get to-the-inch measurements for roofs and elevations in 24 hours or less, reducing time spent on every bid.',
  },
  {
    id: 1,
    icon: iTrendingUp,
    header: 'BID MORE',
    body: 'Don’t miss out on another big opportunity; eliminate the tradeoffs of scaling off measurements and calculating manually with an easy PDF upload solution.',
  },
  {
    id: 2,
    icon: iStar,
    header: 'STAND OUT',
    body: 'Turn a 2D, black & white drawing into a 3D model to instantly demonstrate the products you sell on the unbuilt structure.',
  },
];
